module.exports = __webpack_public_path__ + "img/boxed-theme.a0d1f04d.jpg";